<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center justify-between">
                <div class="flex-sub margin-right">
                    <div class="flex align-center ">
                        <div class="flex align-center margin-right-sm " v-if="[3].includes(user.power)">
                            <span>社区：</span>
                            <el-select v-model="xiangmu_id" placeholder="请选择社区" filterable clearable>
                                <el-option v-for="item in projectList" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="flex align-center margin-right-sm ">
                            <span>商品名称：</span>
                            <el-input v-model="name" placeholder="请输入商品名称" class="flex-sub"></el-input>
                        </div>
                        <div class="flex align-center margin-right-sm ">
                            <span>商品类型：</span>
                            <el-select v-model="show" placeholder="请选择商品类型">
                                <el-option v-for="item in showList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <el-button type="primary" @click="hanldSearch">搜索</el-button>

                        <router-link to="/home/order" class="margin-left">
                            <el-button type="primary">商品订单</el-button>
                        </router-link>
                        <router-link to="/home/shopping-duihuan" class="margin-lr-xs">
                            <el-button type="primary">兑换记录</el-button>
                        </router-link>
                        <router-link to="/home/shopping-caozuo">
                            <el-button type="primary">操作记录</el-button>
                        </router-link>
                    </div>
                </div>
                <div>
                    <el-button type="primary" @click="editItem(0)" v-if="[3].includes(user.power)">添加商品</el-button>
                    <!--                    <el-button type="primary" @click="shoppingOneKeyDialog = true">一键设置</el-button>-->

                </div>

            </div>

            <div class="flex align-center justify-between margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>
                <div>
                </div>
            </div>

            <el-table :data="residentList" header-row-class-name="table-header" row-class-name="table-row" alig="center"
                border style="width: 100%">
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="商品名称" prop="name"></el-table-column>
                <el-table-column label="类型" prop="type">
                    <template slot-scope="scope">
                        {{ scope.row.type === 1 ? '兑换' : '预定' }}
                    </template>
                </el-table-column>
                <el-table-column label="价格（积分）" prop="price"></el-table-column>
                <el-table-column label="库存" prop="num"></el-table-column>
                <el-table-column label="已兑换/预定的数量" prop="order_num"></el-table-column>
                <!--                <el-table-column label="兑换/预定的开始时间" prop="exchange_start_time"></el-table-column>-->
                <!--                <el-table-column label="兑换/预定的结束时间" prop="exchange_end_time"></el-table-column>-->
                <el-table-column label="操作" width="330" v-if="[3].includes(user.power)">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button size="small" type="primary" @click="editItem(scope.row.id)">编辑
                            </el-button>
                            <el-button size="small" type="primary" @click="delItem(scope.row.id)">删除
                            </el-button>
                            <router-link class="margin-left-xs" :to="`/home/shopping-setting?id=${scope.row.id}`"
                                v-if="scope.row.is_zong === 1">
                                <el-button size="small" type="primary">分配库存</el-button>
                            </router-link>
                            <router-link class="margin-left-xs" :to="`/home/shopping-caozuo?id=${scope.row.id}`">
                                <el-button size="small" type="primary">操作记录</el-button>
                            </router-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="residentList.length > 0" class="page-all" background @current-change="getResidentList"
                :current-page.sync="page" :page-size="limit" layout="prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <shopping-one-key-dialog :account-dialog="shoppingOneKeyDialog"
            @cancelDialog="cancelDialog"></shopping-one-key-dialog>
    </div>
</template>

<script>
import { delProduct, productList } from "@/api/weilao";
import ShoppingOneKeyDialog from "@/views/pages/dialog/ShoppingOneKeyDialog";
import { getXiangMuList } from "@/api/common";

export default {
    name: "shopping",
    components: { ShoppingOneKeyDialog },
    data() {
        return {
            showList: [
                { label: '全部', value: 0 },
                { label: '兑换', value: 1 },
                { label: '预定', value: 2 },
            ],
            projectList: [],
            name: '',
            xiangmu_id: '',
            show: '',
            page: 1,
            limit: 10,
            total: 0,
            residentList: [],
            shoppingOneKeyDialog: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", this.$route.path, "双暖为老 / 商城管理", false);
        this.getResidentList()
        this.getXiangMuList()
    },
    methods: {
        //  获取当前人员下的小区
        async getXiangMuList() {
            const project = await getXiangMuList()
            this.projectList = [{ name: '全部', id: 0 }, ...project.data]
        },
        //  商品删除
        delItem(id) {
            this.$confirm('您确定要删除该商品吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureDelete(id);
            });
        },
        async sureDelete(id) {
            let _state = await delProduct(id);
            this.getResidentList();
            this.$message.success(_state.info);
        },
        //  商品编辑
        editItem(id) {
            this.$router.push('/home/shopping-add/' + id)
        },
        //  搜索
        hanldSearch() {
            this.page = 1
            this.getResidentList()
        },
        //  获取商品列表
        async getResidentList() {
            let _data = await productList(
                this.xiangmu_id,
                this.name,
                '',
                this.show,
                this.page,
                this.limit,
            )
            this.residentList = _data.data
            this.total = _data.total_number
        },
        cancelDialog(data) {
            if (data) this.getResidentList()
            this.shoppingOneKeyDialog = false
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss"></style>
